const Menu =  [
    { header: 'Pewawancara' },
    {
        path    : '/',
        title   : 'Form Wawancara',    
        name    : 'tes/survey',  
        icon    : 'local_library', 
    },             
    {
        group: 'tes',
        visible: false,
        items: [                        
            { title : 'List Wawancara', name: 'survey/respon' },
            { title : 'Rekap Wawancara', name: 'survey/respon/rekap' },
            { title : 'Form Wawancara', name: 'survey/respon/form', meta:{breadcrumbs:false} },
        ]
    },    
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
